import React, { memo } from 'react';
export function Hero() {
  return <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden" data-id="element-93">
      {/* Full-bleed Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-94">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jbAZjxE5iByzV2Uo3CGdJR/a-cinematic-hyperrealistic-portrait-of-a_Ge9ieLOLQrSsqMn-Z6scTg_lUxBpBE7RXGcHBY5fw5YjQ.png" alt="Persona serena in paesaggio naturale italiano" className="w-full h-full object-cover" style={{
        aspectRatio: '16/9'
      }} loading="eager" data-id="element-95" />
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.5) 100%)'
      }} data-id="element-96" />
      </div>
      {/* Text Content Directly Over Image */}
      <div className="relative z-10 w-full max-w-5xl px-4 sm:px-6 py-20 text-center" data-id="element-97">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-6 leading-tight" style={{
        textShadow: '2px 4px 12px rgba(0, 0, 0, 0.8), 0 2px 4px rgba(0, 0, 0, 0.6)'
      }} data-id="element-98">
          Ispirato a ricerche di Harvard e dell'INSERM: allena la memoria in 8
          settimane
        </h1>
        <p className="text-lg sm:text-xl md:text-2xl text-white mb-6 max-w-3xl mx-auto leading-relaxed" style={{
        textShadow: '2px 3px 8px rgba(0, 0, 0, 0.8), 0 1px 3px rgba(0, 0, 0, 0.6)'
      }} data-id="element-99">
          Nessuno ti ha mai spiegato come allenare la memoria — finché la
          scienza non ha mostrato che è possibile a ogni età.
        </p>
        <div className="max-w-3xl mx-auto bg-green-600 rounded-2xl px-6 py-4 sm:px-8 sm:py-6" data-id="element-100">
          <p className="text-lg sm:text-xl md:text-2xl text-white font-semibold leading-relaxed" data-id="element-101">
            Scopri cosa succede quando inizi a farlo nel modo giusto.
          </p>
        </div>
      </div>
    </section>;
}